/* eslint-disable max-classes-per-file */
import { DBDocSchema } from '../../generic/db-doc/db-doc-schema';
import { SchemaField } from '../../generic/serialization/schema-field';

export class RolesSchema extends DBDocSchema {
  public static readonly roles = 'roles';

  public static readonly orgNote = 'orgNote';

  public static readonly isDisabled = 'isDisabled';

  ////////////////////////////////////////////////////////////////////////////////////////////////
  // Constants
  ////////////////////////////////////////////////////////////////////////////////////////////////

  public static Constants = class {
    public static readonly collection = 'roles';
  };

  public static Defaults = class {
    public static readonly roles: string[] = [];

    public static readonly orgNote = '';

    public static readonly isDisabled = undefined;
  };

  public static Roles = class {
    public static readonly conversation = 'conversation';

    public static readonly getPII = 'getPII';

    public static readonly orgAdmin = 'orgAdmin';

    public static readonly support = 'support';

    public static readonly voicemail = 'voicemail';
  };

  public static CustomClaims = class {
    public static readonly orgId = 'orgId';
  };

  ////////////////////////////////////////////////////////////////////////////////////////////////
  // Default Values
  ////////////////////////////////////////////////////////////////////////////////////////////////

  /**
   * Specify when to serialize default values
   */
  // eslint-disable-next-line class-methods-use-this
  public defaultValuesToSerialize(): Set<string> {
    return new Set([RolesSchema.orgNote, RolesSchema.roles]);
  }

  ////////////////////////////////////////////////////////////////////////////////////////////////
  // Schema Parameters
  ////////////////////////////////////////////////////////////////////////////////////////////////

  public getSchemaDefinition(): { [key: string]: import('joi').AnySchema } {
    const parameters = super.getSchemaDefinition();

    parameters[RolesSchema.orgNote] = SchemaField.string(RolesSchema.Defaults.orgNote);
    parameters[RolesSchema.roles] = SchemaField.shortStringArray(RolesSchema.Defaults.roles).items(
      RolesSchema.Roles.orgAdmin,
    );
    parameters[RolesSchema.isDisabled] = SchemaField.boolean(RolesSchema.Defaults.isDisabled).optional();

    return parameters;
  }

  ////////////////////////////////////////////////////////////////////////////////////////////////
  // Collection
  ////////////////////////////////////////////////////////////////////////////////////////////////

  public getCollection(orgId: string): string {
    return `${this.orgDoc(orgId)}/${RolesSchema.Constants.collection}`;
  }
}
